export default "__VITE_ASSET__ox410yc8__"